<template>
  <!-- 業務報告一覧 -->
  <div id="monthlyreport">
    <CCard>
      <CCardHeader><h2>業務報告一覧</h2></CCardHeader>
      <CCardBody>
        <table class="table search-table">
          <tr>
            <th style="width: 100px">年月</th>
            <th style="width: 75px"></th>
            <th style="width: 50px"></th>
            <th style="width: 260px">絞り込み</th>
            <th colspan="2"></th>
          </tr>
          <tr>
            <td>
              <select
                class="custom-select preika-control--year"
                v-model="year"
               
              >
                <option
                  v-for="option in yearOption"
                  :value="option.id"
                  :key="option.id"
                >
                  {{ option.name }}
                </option>
              </select>
            </td>
            <td>
              <select
                class="custom-select preika-control--month"
                v-model="month"
               
              >
                <option
                  v-for="option in monthOption"
                  :value="option.id"
                  :key="option.id"
                >
                  {{ option.name }}
                </option>
              </select>
            </td>
            <td>業務分</td>
            <td>
              <!-- 年月と一緒に送る。検索ボタンは1つのまま。 -->
              <input
                v-model="keyword"
                type="text"
                class="form-control"
                maxlength="100"
                placeholder="社員番号・氏名・所属で絞り込む"
                @keyup.enter="search"
              />
            </td>
            <td>
              <button class="btn btn-primary" @click="search">検索</button>
            </td>
          </tr>
        </table>
      </CCardBody>
      <template v-if="callFlg">
        <!-- <CCardHeader><strong>詳細入力</strong></CCardHeader> -->
        <CCardBody>
          <!-- 0件（絞り込みに当たるものが無いときも）は、ほかの一覧と同じ文を、同じ案内の字で、表のすぐ上に出す。 -->
          <p v-if="emptyNote" class="text-muted">{{ emptyNote }}</p>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th scope="col" width="100px">社員名</th>
                  <th scope="col" width="80px">ステータス</th>
                  <th scope="col" width="100px">承認者</th>
                  <th scope="col" width="100px">承認日</th>
                  <th scope="col">差戻し理由</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.name">
                  <td>
                    <router-link
                      :to="{
                        name: reportInfo,
                        params: {
                          id: item.id,
                          user_id: item.user_id,
                          year: searchedYear,
                          month: searchedMonth,
                        },
                      }"
                      >{{ item.userName }}</router-link
                    >
                  </td>
                  <td :style="statusColor(item.status)" nowrap>{{ displayStatus(item) }}</td>
                  <td>{{ item.approver }}</td>
                  <td>{{ item.approval_date }}</td>
                  <td class="linefeed">{{ item.comment }}</td>
                  <td>
                    <save-button
                      v-show="item.status === '承認済み' && canRevokeApproval"
                      :label="'承認取消'"
                      :loading="loading"
                      class="btn btn-danger"
                      @click="revocationOfApproval(item.user_id, item.userName,item.document_type,item.approver_user_id,item.comment,item.submissionId)"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="d-flex justify-content-center">
            <!-- ページング処理 -->
            <VPagination
              v-model="currentPage"
              :click-handler="changePage"
              :page-count="totalPages"
              :force-page="currentPage"
              :force-ellipses="true"
              :container-class="'pagination'"
              :page-class="'page-item'"
              :prev-text="'<'"
              :next-text="'>'"
              :prev-link-class="'page-link'"
              :next-link-class="'page-link'"
              :page-link-class="'page-link'"
              :class-prefix="'pagination'"
            />
          </div>
        </CCardBody>
      </template>
    </CCard>
  </div>
</template>
  
<script>
import SaveButton from "../../common/SaveButton";
import ConstList from "./../../ConstList";
import { requestFailureMessage } from '@/utils/requestFailure';
import axios from "axios";
import { alertSubmissionError } from "../../submission_approval/submissionErrorMessage";
import moment from "moment";
import VPagination from "vuejs-paginate";
import approvalRevocationMixin from "@/mixins/approvalRevocationMixin";
import searchedMonthMixin from "@/mixins/searchedMonthMixin";
export default {
  // ［承認取消］を押せる人にだけ出し、確認の文で取り消したあとを言う（束5）。
  // 行の操作は、選択欄ではなく「いま表に出している月」で動かす（searchedMonthMixin）。
  mixins: [approvalRevocationMixin, searchedMonthMixin],
  name: "MonthlyReport",
  components: {
    SaveButton,
    VPagination,
  },
  data() {
    return {
      year: "",
      month: "",
      date: "",
      items: [],
      // 一覧を読み終えたか（読み込み中・失敗のときは false。0件の文を出すかどうかに使う）
      listLoaded: false,
      // 検索ごとの通し番号。最新の検索の応答だけが、一覧・0件の文・保存する検索条件を変える（古い応答は捨てる）
      listRequestNo: 0,
      callFlg: false,
      monthlyReportInfo: "",
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      // いま効いている絞り込みの言葉。空なら絞り込んでいない。
      keyword: "",
      loading: false,
    };
  },
  created() {
    this.yearOption = ConstList.YEAR_OPTION;
    this.monthOption = ConstList.MONTH_OPTION;
    this.reportInfo = ConstList.ROUTE_REPORT_INFO;
  },

  methods: {
    callList: function () {
      this.listLoaded = false;
      /*
       * **検索を重ねても、最新の検索の結果だけを画面に出す。**
       * 応答は頼んだ順に返るとは限らない。先の検索があとから返ると、新しい結果を古い結果で上書きし、
       * 古い検索の0件の文が、新しい検索の途中や失敗のあとにも出ていた。
       * 保存する検索条件も、返ったときの画面の値ではなく、頼んだときの値にする。
       */
      const requestNo = ++this.listRequestNo;
      const asked = {
        year: this.year,
        month: this.month,
        keyword: this.keyword,
        currentPage: this.currentPage,
        pageSize: this.pageSize,
      };
      this.callFlg = false;
      // この検索の月を、表に出す月として覚える（行の操作はこの月で動く）。
      this.rememberSearchedMonth();
      const params = new URLSearchParams();
      params.append("year", this.year);
      params.append("month", this.month);
      this.fetchTotalPages();
      params.append("currentPage", this.currentPage);
      params.append("pageSize", this.pageSize);
      params.append("totalPages", this.totalPages);
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/admin/monthlyReport/List", {
          params: {
            year: this.year,
            month: this.month,
            currentPage: this.currentPage,
            pageSize: this.pageSize,
            // 空文字は渡さない。渡すとサーバ側で「空で絞り込む」形になりうる。
            keyword: this.keyword || undefined,
          },
        })
        .then((response) => {
          // 古い検索の応答は捨てる。
          if (requestNo !== this.listRequestNo) return;
          // 待つあいだに選択欄を変えていたら、表を開かない（選択欄と違う月の表で操作させない）。
          if (!this.isStillSearchedMonth(asked.year, asked.month)) return;
          this.items = response.data;
          this.listLoaded = true;
          this.callFlg = true;
          // sessionStorageへ保存
          sessionStorage.setItem(
            "monthlyreportsList-search-items",
            JSON.stringify(this.items)
          );
          sessionStorage.setItem(
            "monthlyreportsList-search-params",
            JSON.stringify({
              year: asked.year,
              month: asked.month,
              // 年月と同じように、戻ってきたときの絞り込みも覚えておく。
              keyword: asked.keyword,
              currentPage: asked.currentPage,
              pageSize: asked.pageSize,
              totalPages: this.totalPages,
            })
          );
        })
        .catch((error) => {
        // 失敗の記録は、古い検索のものでも今までどおり送る（不具合を追う手がかり。記録を減らさない）。
        // 知らせを出すのは、記録を送り終えた時点でも最新の検索のときだけ（下のコールバックで確かめる）。
        axios
          .post(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError`,
            { error: String(error) },
            {
              headers: {
                'Content-Type': 'application/json'
              }
            }
          )
          .then(() => {
            // 記録を送るのを待つあいだに次の検索が始まっていたら、古い検索の失敗は知らせない（記録は送ってある）。
            if (requestNo !== this.listRequestNo) return;
            alert(requestFailureMessage(error));
          })
          .catch(() => {
            // 記録を送るのを待つあいだに次の検索が始まっていたら、古い検索の失敗は知らせない（記録は送ってある）。
            if (requestNo !== this.listRequestNo) return;
            alert(requestFailureMessage(error, ConstList.SYSTEM_COMMUNICATION_ERROR));
          })
        });
    },
    setBlue: function (bluenum, index) {
      if (this.blue[index][bluenum] === "blue") {
        this.blue[index].splice(bluenum, 1, "");
      } else {
        this.blue[index].splice(bluenum, 1, "blue");
      }
    },
    setYellow: function (yellownum, index) {
      if (this.yellow[index][yellownum] === "yellow") {
        this.yellow[index].splice(yellownum, 1, "");
      } else {
        this.yellow[index].splice(yellownum, 1, "yellow");
      }
    },
    /*
     * 表示用の状態。**この一覧の行は、保存された業務報告だけ。**
     * 状態が無い行は、本人が申請リストから除外した月（提出の行だけが消える）。
     * 前は空欄で、未申請なのか除外したのか分からなかった（束5）。
     */
    displayStatus(item) {
      return (item && item.status) || ConstList.EXCLUDED_FROM_LIST;
    },
    // 承認状態の識別
    statusColor(status) {
      switch (status) {
        case ConstList.REJECT:
        case ConstList.UNSUBMITTED: 
          return { color: 'red' };
        case ConstList.APPROVAL_PENDING:
          return { color: 'orange' };
        case ConstList.APPROVAL:
          return { color: 'green' };
        default:
          return {};
      }
    },
    // 検索ボタン（およびEnter）
    //
    // **ページを1へ戻してから検索する。**5ページ目のまま絞り込むと、
    // 結果が1ページしか無いときに空の表になる。
    // ページ送り（changePage）は callList を直接呼ぶので、この処理を
    // callList の中に入れてはいけない。
    search: function () {
      this.currentPage = 1;
      this.callList();
    },
    // ページ変更
    changePage: function (page) {
      this.currentPage = page;
      this.callList();
    },
    // アイテム数とページサイズに基づいて合計ページ数を計算
    fetchTotalPages: function () {
      // 一覧と同じ検索の通し番号（callList が進めたあとに呼ばれる）。最新の検索の件数だけが、ページ数を変える。
      // 先の検索の件数があとから返ると、新しい検索の一覧に、古い検索のページ数が付いていた。
      const requestNo = this.listRequestNo;
      const params = new URLSearchParams();
      params.append("year", this.year);
      params.append("month", this.month);
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/admin/monthlyReport/count", {
          params: {
            year: this.year,
            month: this.month,
            // **一覧と同じ言葉で数える。**片方だけだとページ送りが壊れる。
            keyword: this.keyword || undefined,
          },
        })
        .then((response) => {
          // 古い検索の件数は捨てる。
          if (requestNo !== this.listRequestNo) return;
          const totalCount = response.data;
          // **ページ数は最低1。**Math.ceil(0 / 10) は 0 で、0件のときに
          // ページャそのものが消えてしまう。
          this.totalPages = Math.max(1, Math.ceil(totalCount / this.pageSize));
          // 数え直したあとに、見ているページを 1〜totalPages へ収める。
          // 覚えていたページへ戻ったとき、そのあいだに件数が減っていると
          // 空の表になるので、収めた側で引き直す。
          const inRange = Math.min(Math.max(1, this.currentPage), this.totalPages);
          if (inRange !== this.currentPage) {
            this.currentPage = inRange;
            this.callList();
          }
        })
        .catch((error) => {
        // 失敗の記録は、古い検索のものでも今までどおり送る（不具合を追う手がかり。記録を減らさない）。
        // 知らせを出すのは、記録を送り終えた時点でも最新の検索のときだけ（下のコールバックで確かめる）。
        axios
          .post(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError`,
            { error: String(error) },
            {
              headers: {
                'Content-Type': 'application/json'
              }
            }
          )
          .then(() => {
            // 記録を送るのを待つあいだに次の検索が始まっていたら、古い検索の失敗は知らせない（記録は送ってある）。
            if (requestNo !== this.listRequestNo) return;
            alert(requestFailureMessage(error));
          })
          .catch(() => {
            // 記録を送るのを待つあいだに次の検索が始まっていたら、古い検索の失敗は知らせない（記録は送ってある）。
            if (requestNo !== this.listRequestNo) return;
            alert(requestFailureMessage(error, ConstList.SYSTEM_COMMUNICATION_ERROR));
          })
        });
    },
    // 承認取消メソッド
    //
    // user_name には item.userName を渡すこと。この一覧の応答
    // （MonthlyReportListResponseForm）が持つのは userName で、user_name は
    // 存在しない。表示（上の氏名リンク）は userName を使っていたのに、この
    // ボタンだけ user_name を渡していたため、確認ダイアログが
    // 「undefinedさんの…承認を取り消してもよろしいですか？」になっていた。
    // 誰の承認を消すのか分からないままOKを押すことになる。
    revocationOfApproval: function (user_id, user_name,document_type,approver_user_id,comment,id) {
      if (
        confirm(
          this.revocationConfirmMessage(
          user_name +
            "さんの" +
            this.searchedYear +
            "年" +
            this.searchedMonth +
            "月" +
            "の承認を取り消してもよろしいですか？")
        )
      ) {
        this.loading = true;
        this.sendList = [];
        const selectItem = {
        user_id: user_id,
        // 表に出ている行の月（検索した月）。選択欄の月ではない。
        year: this.searchedYear,
        month: this.searchedMonth,
        id: id,
        approver_user_id:
        approver_user_id === null ? user_id : approver_user_id,
        comment: comment,
        document_type: document_type,
        sns_message: this.sns_message,
      };
      this.sendList.push(selectItem);
      // 非同期処理
      axios
        .post(
          process.env.VUE_APP_API_ORIGIN + "/submission/revocation_of_approval",
          this.sendList
        )
        .then(() => {
          alert("承認を取り消しました");
          window.location.reload();
          this.callList();
        })
        .catch((error) => {
          /*
           * **断られた理由をそのまま出す。**
           *
           * 権限が足りないとき 403 が返る。実機で common の利用者にも承認取消ボタンが出ていた。
           * サーバは message に利用者向けの文言を載せている。それを
           * 「システムエラーです。管理者に問い合わせてください。」へ
           * 置き換えると、**何をすれば通るのかが分からない。**
           */
          alertSubmissionError(error);
        })
        .finally(() => {
          this.loading = false;
        });
      }
    },
  },

  computed: {
    // 0件のときの案内。一覧を読み終えて0件のときだけ出す（開き直したときは読み込む前に表が出るので、件数だけでは決めない）。
    emptyNote: function () {
      return this.listLoaded && Array.isArray(this.items) && this.items.length === 0 ? ConstList.EMPTY : '';
    },
    // 入力欄を追加・削除出来るようにする
    lists: function () {
      return Array.from(Array(this.num).keys());
    },
  },

  mounted: function () {
    // 前回の検索パラメータがあれば取得。
    //
    // **確かめる鍵と、読む鍵を同じにする。**別の鍵（-items）の有無で
    // 判定して -params を読むと、片方だけ残っているときに
    // JSON.parse(null) で落ちる。
    const saved = sessionStorage.getItem("monthlyreportsList-search-params");
    if (saved) {
      //this.callFlg = true;
      //this.items = JSON.parse(
      //  sessionStorage.getItem("monthlyreportsList-search-items")
      //);
      const params = JSON.parse(saved);
      this.year = params.year;
      this.month = params.month;
      // 以前に保存した分には keyword が無い。その場合は絞り込み無しに戻す。
      this.keyword = params.keyword || "";
      // **見ていたページへ戻す。**保存しているのだから復元する。
      // 件数が減っていることがあるので、数え直したあと
      // （fetchTotalPages）に 1〜totalPages へ収める。
      this.currentPage = Number(params.currentPage) || 1;
      this.callList();
      this.callFlg = true;
      //this.pageSize = params.pageSize;
      //this.totalPages = params.totalPages;
    }else{
      const today = moment().subtract(1, 'months');
      this.year = today.format("YYYY");
      this.month = today.format("M");
    }
  },
};
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  
<style scoped>
td,
th {
  white-space: nowrap;
}
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

td {
  vertical-align: middle;
  white-space: nowrap;
  padding-top: 0;
  padding-bottom: 0;
}
</style>
